import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import { Icon } from '@components/icons';
import { useTranslation } from 'react-i18next';

const LockCardModal = () => {
    const { t } = useTranslation('modals', {
        keyPrefix: 'lock_card'
    });
    return (
        <div className={styles.wrapper}>
            <Icon name="lock" width={80} height={80} />
            <Typography className={styles.title} variant="h4">
                {t('title')}
            </Typography>
            <Typography className={styles.description} variant="body2">
                {t('description')}
            </Typography>
        </div>
    );
};

export default LockCardModal;
